import { ReactNode } from 'react';
import type { SortDir } from '../utilities/sort';

interface Props<K extends string> {
  label: ReactNode;
  sortKey: K;
  current: K;
  dir: SortDir;
  onSort: (k: K) => void;
}

// Clickable column header that displays the active sort direction.
export function SortableTh<K extends string>({ label, sortKey, current, dir, onSort }: Props<K>) {
  const active = current === sortKey;
  return (
    <th style={{ cursor: 'pointer' }} onClick={() => onSort(sortKey)}>
      {label}{' '}
      {active && <i className={`fas fa-sort-${dir === 'asc' ? 'up' : 'down'}`} aria-hidden="true" />}
    </th>
  );
}
